import { createSlice } from "@reduxjs/toolkit";

export const thisTutorSlice = createSlice({
  name: "thisTutorr",
  initialState: { thisTutor: null },
  reducers: {
    set: (state, action) => {
      state.thisTutor = action.payload;
    },
  },
});

export const thisTutorActions = thisTutorSlice.actions;
export default thisTutorSlice;
